import { startCase } from 'lodash-es'
import { METADATA_TRANSLATIONS } from '../config'

export function getDisplayLabel(label: string) {
  return METADATA_TRANSLATIONS[label] ?? startCase(label)
}
